import CardTimePanel from './CardTimePanel'
import { getInitials } from './cardDetailUtils'

function formatCreatedAt(value) {
    if (!value) return ''
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''
    return new Intl.DateTimeFormat(document.documentElement.lang || 'ro-RO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(date)
}

export default function CardTicketDetailsPanel({
    t,
    card,
    companyMembers,
    effectiveTimerStartedAt,
    timeLogs,
    groupedTimeLogs,
    activeTimer,
    viewSession,
    effectiveIsCompleted,
    userId,
    loadingAverage,
    averageMinutes,
    afterPoints,
}) {
    const creator = card?.created_by
        ? (companyMembers || []).find((member) => member.id === card.created_by)
        : null
    const creatorName = creator?.full_name || creator?.email
    const createdAt = formatCreatedAt(card?.created_at)

    return (
        <>
            {creatorName ? (
                <div className="cd-created-by-row cd-created-by-standalone">
                    <span className="cd-field-label">{t('card.sidebar.createdBy', { defaultValue: 'Creat de' })}</span>
                    <div className="cd-created-by">
                        <span className="cd-created-by-avatar">{getInitials(creatorName)}</span>
                        <span className="cd-created-by-details">
                            <span className="cd-created-by-name">{creatorName}</span>
                            {createdAt ? <time className="cd-created-at" dateTime={card.created_at}>{createdAt}</time> : null}
                        </span>
                    </div>
                </div>
            ) : null}

            <CardTimePanel
                t={t}
                card={card}
                timeLogs={timeLogs}
                groupedTimeLogs={groupedTimeLogs}
                activeTimer={activeTimer}
                viewSession={viewSession}
                effectiveIsCompleted={effectiveIsCompleted}
                effectiveTimerStartedAt={effectiveTimerStartedAt}
                userId={userId}
                companyMembers={companyMembers}
                loadingAverage={loadingAverage}
                averageMinutes={averageMinutes}
            />

            <div className="card-detail-sidebar-section cd-comments-card">
                {afterPoints}
            </div>
        </>
    )
}
